"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var PriceMatrixDaysCount = function PriceMatrixDaysCount(props) {
  var target = props.target,
    durationsCount = props.durationsCount,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: className
  }, durationsCount.map(function (count) {
    return /*#__PURE__*/_react["default"].createElement(Container, {
      isTarget: count === target.nights,
      key: count
    }, count);
  }));
};
var Container = _styledComponents["default"].li.withConfig({
  displayName: "PriceMatrixDaysCount__Container",
  componentId: "sc-1ce9gh4-0"
})(["width:24px;height:42px;font-size:12px;color:#919499;display:flex;align-items:center;justify-content:center;margin-top:1px;", ""], function (_ref) {
  var isTarget = _ref.isTarget;
  return isTarget && "\n    font-weight: 500;\n    background: rgba(248, 231, 28, 0.26);\n    border-radius: 4px 0 0 4px;\n    color: #17181A;\n  ";
});
var _default = exports["default"] = PriceMatrixDaysCount;